export default __webpack_public_path__ + "static/media/ic_order_session_unselected.22de883a.svg";